import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";
import { showAccessDeniedModal } from "../slices/authSlice";

const getStore = () => require("../store").store;

export const INPUT_GROUP_API_REDUCER_KEY = "inputGroupApi";

export const inputGroupApi = createApi({
  reducerPath: INPUT_GROUP_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["input-group"],
  endpoints: (builder) => ({
    createInputGroup: builder.mutation({
      query: (body) => ({
        url: `/emissions/emission-input-groups/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["input-group"],
    }),

    getInputGroup: builder.query({
      query: (inputGroupId) => {
        if (!inputGroupId) {
          return;
        }
        return {
          url: `/emissions/emission-input-groups/id/${inputGroupId}/`,
        };
      },

      providesTags: ["input-group"],
    }),
    getInputGroupList: builder.query({
      query: ({ page = 1, limit = 100, year, organization_taxonomy }) => {
        const params = {
          page,
          limit,
          year,
          organization_taxonomy,
        };

        // Filter out undefined parameters
        const filteredParams = Object.fromEntries(
          Object.entries(params).filter(([_, v]) => v !== undefined)
        );

        return {
          url: `/emissions/emission-input-groups/`,
          params: filteredParams,
        };
      },
      providesTags: ["input-group"],
    }),
    inputGroupPeriods: builder.query({
      query: ({ company, site }) => {
        if (!company || !site) {
          return;
        }
        return {
          url: `/emissions/emission-input-groups/?company=${company}&company_site=${site}&limit=100`,
        };
      },
      providesTags: ["input-group"],
    }),
    deleteInputGroup: builder.mutation({
      query: (inputGroupId) => {
        const { permissions } = getStore().getState().auth;
        console.log("permissions store", permissions);
    
        if (!["R", "W", "D"].every((perm) => permissions.includes(perm))) {
          getStore().dispatch(showAccessDeniedModal());
          throw new Error("403: Access Denied"); 
        }
    
        return {
          url: `/emissions/delete-input-group/${inputGroupId}/`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["input-group"],
    }),    
  }),
});

export const {
  useCreateInputGroupMutation,
  useGetInputGroupQuery,
  useGetInputGroupListQuery,
  useDeleteInputGroupMutation,
  useInputGroupPeriodsQuery,
} = inputGroupApi;
